import { isClient } from '@shared/utils/is-client'

/**
 * Вызывать перед отправкой лида.
 * Возвращаемый результат подставлять в поле marketingData в теле запроса
 */
export function getMarketingData() {
	return isClient ? window.MarketingData?.get() : undefined
}
